'use client';

import { LearningPathByIdEventKeys, LearningPathByIdEvents } from '../events';
import { EventBus } from '@/shared/utils';

/* Retrive localstorage user and redirect to /percorsi if user is not logged in */
const screenWithAuth = (
  eventBus: EventBus<LearningPathByIdEvents>,
  Component: JSX.Element,
): JSX.Element | null => {
  const localStorageUser = localStorage.getItem('auth-storage') || '';

  if (!localStorageUser) {
    eventBus.emit(LearningPathByIdEventKeys.redirects.to, '/auth/login');
  }

  if (!localStorageUser) return null;

  return Component;
};

export default screenWithAuth;
